import Wave from 'react-wavify'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
// style
import '../style/profile.css';

const Profile = (props :any) => {

  const profileList = [{
    sub: "FAN MARK",
    data: "🌸🤍"
  },{
    sub: "FAN NAME",
    data: "かなみんてぃあ"
  },{
    sub: "あいさつ",
    data: "はろわー, おつかなみ"
  },{
    sub: "誕生日",
    data: "7月3日"
  },{
    sub: "身長",
    data: "158cm"
  },{
    sub: "すきなこと",
    data: "歌、ホラーゲーム、お絵描き"
  }];

  const tagList = [{
    sub: "ALL",
    data: "#花波のはなうた"
  },{
    sub: "FAN ART",
    data: "#花波のはなたば"
  },{
    sub: "配信",
    data: "#花波アクセス中"
  },];

  const historyList = [{
    date: "2024.05.11",
    description: "活動開始"
  },{
    date: "2025.03.19",
    description: "チャンネル登録者1,000名様達成"
  },{
    date: "2025.04.11",
    description: "配信デビュー"
  },{
    date: "2025.11.23",
    description: "初リアルイベント「ぶいかふぇ♪NEXT vol.50」出演"
  },{
    date: "2026.3.22",
    description: "リアルイベント「ねくすてーじSP」出演"
  },];

  return (
    <div id="profile-page">
      <div className='wave-wrap1'>
        <Wave
          fill='#a5d2fd'
          paused={false}
          style={{ display: 'flex' }}
          options={{
            height: 20,
            amplitude: 15,
            speed: 0.15,
            points: 5
          }}
        />
      </div>
      <div className='wave-wrap2'>
        <Wave
          fill='#e0f0ffff'
          paused={false}
          style={{ display: 'flex' }}
          options={{
            height: 20,
            amplitude: 15,
            speed: 0.15,
            points: 4
          }}
        />
        <div className='wave-background'/>
      </div>
      <div className='content-wrap'>
        <div className='title'>-PROFILE-</div>
        <div className='link-wrap'>
          <div>
            <a href="https://x.com/kanami_k73" className="flowbtn my_x1">
              <i className="fa-brands fa-x-twitter"></i>
            </a>
          </div>
          <div>
            <a href="https://www.youtube.com/@kanami-channel" className="flowbtn my_youtube1">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
          <div>
            <a href="https://raidori.com/@kanami_k73" className="flowbtn fanclub">
              <div>FAN</div>
              <div>CLUB</div>
            </a>
          </div>
          <div>
            <a href="https://gi-pt.com/main/wishlist/fan-view/3a167edc-c5be-4afc-858b-e7268cd7df69" className="flowbtn gift">
              <CardGiftcardIcon/>
            </a>
          </div>
        </div>
        <div className='profile-list list-wrap'>
          {profileList.map(item => (
            <div className='list-item'>
              <div>{item.sub}</div>
              <div>{item.data}</div>
            </div>
          ))}
        </div>
        <div className='title'>-TAGS-</div>
        <div className='profile-list list-wrap'>
          {tagList.map(item => (
            <div className='list-item'>
              <div>{item.sub}</div>
              <div>{item.data}</div>
            </div>
          ))}
        </div>
        <div className='title'>-HISTORY-</div>
        <div className='history list-wrap'>
          {historyList.map(item => (
            <div className='history-item'>
              <div className='date'>{item.date}</div>
              <div className='event'>{item.description}</div>
            </div>
          ))}
        </div>
      </div>
      <div className='wave-wrap3'>
        <Wave
          fill='#fff'
          paused={false}
          style={{ display: 'flex' }}
          options={{
            height: 5,
            amplitude: 10,
            speed: 0.15,
            points: 4
          }}
        />
      </div>
      <div className='copy'>
        🄫 2024 花波-kanami-
      </div>
    </div>
  );
};

export default Profile;